import { defineComponent, createElementBlock, openBlock, createElementVNode, createVNode, toDisplayString, withCtx, createTextVNode } from 'vue';
import _sfc_main$1 from './basler-components.es175.js';
/* empty css                        */

const _hoisted_1 = { class: "newsletter-registration" };
const _hoisted_2 = { class: "newsletter-registration__headline" };
const _hoisted_3 = { class: "newsletter-registration__copy" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NewsletterRegistration",
  props: {
    headline: {},
    copy: {},
    placeholder: {},
    submitButtonLabel: {}
  },
  emits: ["submit-form"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const emitValue = (value) => {
      emit("submit-form", value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("h4", _hoisted_2, toDisplayString(_ctx.headline), 1),
        createElementVNode("p", _hoisted_3, toDisplayString(_ctx.copy), 1),
        createVNode(_sfc_main$1, {
          "input-id": "newsletter-email-field",
          "input-type": "email",
          "input-is-required": true,
          "onSubmit:modelValue": emitValue,
          "icon-name": "paper-plane",
          "submit-button-label": props.submitButtonLabel
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.placeholder), 1)
          ]),
          _: 1
        }, 8, ["submit-button-label"])
      ]);
    };
  }
});

export { _sfc_main as default };
